import React from 'react'

import { SearchBox, SUI, Divider } from 'shared/ui'
import List from './List'

const SearchableList = ({
  onSearch,
  onClear,
  onSearchBoxChange,
  placeholder,
  searchTerm,
  hidden,
  ...rest
}) => {
  return (
    <React.Fragment>
      {!hidden && (
        <SearchBox
          className="grui ml-12 mt-4"
          onClear={onClear}
          onSearchChange={onSearch}
          placeholder={placeholder}
          value={searchTerm}
        />
      )}
      <SUI>
        <Divider />
      </SUI>
      <List {...rest} />
    </React.Fragment>
  )
}

export default SearchableList
